import Vue from "vue";
import Component from "vue-class-component";
import Moment from "moment";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "FestivalFilterBox" })
export default class FestivalFilterBox extends Vue {
    public localizer: any = Localizer;
    public typeFilter: string = (<any>window).App.bag.TypeFilter;
    public dateFilter: string = (<any>window).App.bag.DateFilter !== "all" ? (<any>window).App.bag.DateFilter : "all";

    get routes() {
        return (<any>window).App.routes;
    }

    get festival() {
        return (<any>window).App.bag.Festival;
    }

    get types() {
        return (<any>window).App.bag.Types;
    }

    get festivalDetailUrl() {
        return (<any>window).App.bag.FestivalDetailUrl;
    }

    get festivalDates() {
        return (<any>window).App.bag.FestivalDates;
    }

    get language() {
        return (<any>window).App.bag.Language;
    }

    get pageType() {
        return (<any>window).App.bag.Page;
    }

    public created() {
        Moment.locale("it", {
            months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            monthsShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
            monthsParseExact: true,
            weekdays: ["Luned�", "Marted�", "Mercoled�", "Gioved�", "Venerd�", "Sabato", "Domenica"],
            weekdaysShort: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"]
        });
    }

    public setTypeValue(typeValue: string) {
        if (this.dateFilter === "") {
            this.dateFilter = "all"
        }

        if (this.pageType == "EventDetail") {
            this.setSearch(typeValue, "all");
        } else {
            this.setSearch(typeValue, this.dateFilter);
        }
    }

    public setDateValue(dateValue: string) {
        if (this.typeFilter === "") {
            this.typeFilter = "all"
        }

        if (this.pageType == "EventDetail") {
            this.setSearch("all", dateValue);
        } else {
            this.setSearch(this.typeFilter, dateValue);
        }
    }

    public setDateSelected(date: string) {
        if (Moment(this.dateFilter).format("YYYY-MM-DD") === Moment(date).format("YYYY-MM-DD")) {
            return true
        } else {
            return false;
        }
    }

    public setFestivalSelected() {
        var result = false;

        if ((!this.typeFilter && this.typeFilter === "") && (!this.dateFilter && this.dateFilter === "")) {
            result = true;
        }

        return result;
    }

    public setSearch(typeFilter: string, dateFilter: string) {
        let filters = [],
            filterCount = 0,
            queryString = "",
            festivalDetailUrl = this.festivalDetailUrl;

        if (typeFilter) {
            filters.push("typeFilter=" + typeFilter);
            filterCount++;
        }

        if (dateFilter) {
            if (dateFilter && dateFilter !== "all") {
                dateFilter = Moment(dateFilter).format("YYYY-MM-DD").toString();
            }

            filters.push("dateFilter=" + dateFilter);
            filterCount++;
        }

        if (filterCount !== 0) {
            queryString = filters.join("&");
            window.location.href = this.festivalDetailUrl + "?" + queryString;
        } else {
            window.location.href = this.festivalDetailUrl;
        }
    }

    public setDateToString(date: any) {
        return Moment(date).format("YYYY-MM-DD");
    }

    public setDayToString(date: any) {
        return Moment(date).format("DD");
    }

    public setMonthToString(date: string) {
        return Moment(date).locale(this.language).format("MMM");
    }
};